module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0007.43bb698c.jpg";